import FieldSet from '../../FieldSet';
import terminology from 'javascripts/terminology';
import { InitiativesCount } from './InitiativesCount';

export class InitiativesFieldSet extends FieldSet {
  get fieldDefinitions() {
    return [InitiativesCount];
  }

  get title() {
    return terminology('Initiatives');
  }
}
